<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug">
</template>

<script>
export default {
  name: "wl-select",
  props: {
    empty_name: {
      type: String,
      required: false,
      default: '请选择'
    },
    column_list: {
      type: Array,
      required: false,
    },
    prop: {
      type: String,
      required: false,
      default: 'text'
    },
    val: {
      required: false
    },
  },
  components: {},
  data() {
    return {
      showPicker: false,
      selectIndex: null,
    };
  },
  watch: {
    column_list(val){
      console.log(val);
      //默认值
      var ind  = null;
      this.column_list.map((r,index)=>{
        if(r.value==this.val){
          ind = index;
        }
      })
      console.log(this.column_list);
      this.selectIndex = ind;
    }
  },
  computed: {},
  mounted() {

  },
  methods: {
    //打开选择框
    openPicker(){
      this.showPicker = true;
    },
    //确认选择框
    onConfirm(value, index){
      this.selectIndex = index;
      this.$emit('confirm',{value,index})
      this.showPicker = false;
    },
    //监听选择框切换
    onChange(picker, value, index){
      this.$emit('change',{picker,value,index})
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/wl-select/index.vue